import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoColaboradoresColaboradorUsuarioDesvincularComponent {
  colaborador
  desvinculando = false
  idColaborador
  idProyecto
  onClose
  username

  constructor (ViaticosColaboradorUsuarioService) {
    this.ViaticosColaboradorUsuarioService = ViaticosColaboradorUsuarioService
  }

  desvincular () {
    this.desvinculando = true
    this.ViaticosColaboradorUsuarioService.delete(this.idProyecto, this.idColaborador)
      .then(() => {
        this.username = null
        this.desvinculando = false
      })
      .catch((error) => (console.log(error)))
      .finally(() => (this.desvinculando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: {username: this.username}}})
  }
}

module.component('viaticosConfiguracionProyectoColaboradoresColaboradorUsuarioDesvincular', {
  controller: ViaticosConfiguracionProyectoColaboradoresColaboradorUsuarioDesvincularComponent,
  template,
  bindings: {
    colaborador: '<',
    idColaborador: '<',
    idProyecto: '<',
    onClose: '&',
    username: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/colaboradores/colaborador/usuario/desvincular/component.js